import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { SignalSection } from '../components/SignalSection';
import { DifferenceSection } from '../components/DifferenceSection';
import { PainSection } from '../components/PainSection';
import { BenefitsSection } from '../components/BenefitsSection';
import { ProtocolSection } from '../components/ProtocolSection';
import { ForWhoSection } from '../components/ForWhoSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { BibliotecaSection } from '../components/BibliotecaSection';
import { OfferSection } from '../components/OfferSection';
import { AboutSection } from '../components/AboutSection';
import { FAQSection } from '../components/FAQSection';
import { FinalCTASection } from '../components/FinalCTASection';
export function LandingPage() {
  return <main className="overflow-hidden bg-background text-foreground min-h-screen font-body" data-id="element-259">
      <HeroSection data-id="element-260" />

      <SignalSection data-id="element-261" />

      <ProtocolSection data-id="element-262" />

      <BenefitsSection data-id="element-263" />
      <PainSection data-id="element-264" />

      <TestimonialsSection data-id="element-265" />

      <DifferenceSection data-id="element-266" />

      

      <ForWhoSection data-id="element-267" />

      <BibliotecaSection data-id="element-268" />

      <OfferSection data-id="element-269" />

      <AboutSection data-id="element-270" />

      <FAQSection data-id="element-271" />

      <FinalCTASection data-id="element-272" />
    </main>;
}